import clsx from 'clsx';
import React from 'react';

type Props = {
  message: string;
  Icon: React.ReactNode;
  date?: string;
  isRead: boolean;
};

export default function NotificationItem({ message, Icon, date, isRead }: Props) {
  return (
    <div
      className={clsx(
        'w-full p-3 rounded flex mb-2 shadow-sm bg-white text-gray-800', // default light mode
        isRead
          ? 'dark:bg-gray-800 dark:text-white' // dark mode read
          : 'bg-blue-50 dark:bg-blue-900 dark:text-white' // dark mode unread
      )}
    >
      <div
        aria-label="icon"
        role="img"
        className="focus:outline-none w-10 h-8 border rounded-full border-gray-200 dark:border-gray-600 flex items-center justify-center"
      >
        {Icon}
      </div>
      <div className="pl-3 flex-1">
        <p className="focus:outline-none text-sm leading-none">
          <span
            className="text-gray-600 dark:text-gray-300 text-xs"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </p>
        {date && (
          <p className="focus:outline-none text-xs leading-3 pt-1 text-gray-500 dark:text-gray-400">
            {date}
          </p>
        )}
      </div>
    </div>
  );
}
